import React from 'react';
import { useIntl } from 'react-intl';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';
import selectors from '../hooks/selectors';
import { cohortChanged } from '../helper';
import events from '../hooks/events';

const CancelCohortAction = ({ category, code }) => {
  const intl = useIntl();
  const { cohort, isDirty } = selectors.useCancelCohortAction({ category, code });
  const refresh = events.useRefreshCohort(category, { code });
  const cancelUpdate = events.useUpdateCohortCancel(category, { code });
  const handleOnClick = () => {
    const updates = cohortChanged(cohort);
    const cancel = !isDirty
        || !updates
        || window.confirm(intl.formatMessage({ id: 'cohort.edit.cancel.warning' }));

    if (cancel) {
      if (updates) { refresh(); }
      cancelUpdate({ isNew: false });
    }
  };

  return (
    <RibbonMenu
      icon="cancel"
      name="cancel"
      message="actions.cancel"
      onClick={handleOnClick}
      className="aridhia-cancel-cohort-action"
    />
  );
};

export default CancelCohortAction;
